import React, { Component } from 'react';
import { AppContext } from "../context/applicationContext";


class Spinner extends Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <span><div className="spinner-bg"></div><div className="lds-spinner align-center"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></span>
        );
    }
}

export default Spinner;

